import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { ActivitiesList } from "./ActivitiesList";
import Drawer from "react-modern-drawer";
import { useActivityLogsController } from "shared/queries/useActivityLogsController";
import { Loader } from "shared/components/Loader";
import { useMedia } from "shared/providers";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { useEffect } from "react";
import type { ActivityApplicant } from "shared/app/ActivityLog/helpers";
import { track } from "shared/telemetry/track";

export const ActivityLog = ({
  showActivityLog,
  setShowActivityLog,
  applicationId,
  applicants,
  propertyName
}: {
  showActivityLog: boolean;
  setShowActivityLog: (value: boolean) => void;
  applicationId: string;
  applicants?: ActivityApplicant[];
  propertyName?: string;
}) => {
  const { activityLogsMeta } = useActivityLogsController(applicationId);

  const { isMobile } = useMedia();

  useEffect(() => {
    if (!showActivityLog) return;
    track("application.activity_log.page_view", {
      application_id: applicationId
    });
  }, [showActivityLog, applicationId]);

  return (
    <Drawer
      className="rounded-l-lg"
      direction="right"
      onClose={() => {
        setShowActivityLog(false);
      }}
      open={showActivityLog}
      size={isMobile ? 380 : 640}
    >
      <div className="flex h-screen flex-col">
        <div className="flex items-center justify-between border-b border-alpha-80 px-6 py-4">
          <p className="text-xl font-bold text-content-1000">Activity log</p>
          <IconButton
            onClick={() => setShowActivityLog(false)}
            variant={IconButtonVariant.TEXT_BASE}
            size={IconButtonSize.SM}
            HugeIcon={Cancel01Icon}
            className="stroke-content-1000"
          />
        </div>

        <div className="flex-grow overflow-y-auto">
          {activityLogsMeta.isLoading ? (
            <div className="flex items-center justify-center pt-10">
              <Loader />
            </div>
          ) : (
            <ActivitiesList
              propertyName={propertyName}
              activityLogs={activityLogsMeta.data || []}
              applicationId={applicationId}
              applicants={applicants}
              closeActivityLog={() => setShowActivityLog(false)}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
};
